<template>
  <v-container fluid class="fill-height">
    <v-row v-if="dashboard" no-gutters class="full-height">
      <v-col no-gutters cols="12">
        <v-row
          justify="space-between"
          class="row-section row-odd contain-width"
        >
          <v-col cols="4" class="widget widget-top widget-left inner">
            <component
              :is="dashboard.position1"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position1"
              position="position1"
              :widget-data="dashboard[dashboard.position1]"
              alignment="left"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
          <v-col cols="4" class="widget widget-top widget-center inner">
            <component
              :is="dashboard.position2"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position2"
              position="position2"
              :widget-data="dashboard[dashboard.position2] || null"
              alignment="center"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
          <v-col cols="4" class="widget widget-top widget-right inner">
            <component
              :is="dashboard.position3"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position3"
              position="position3"
              :widget-data="dashboard[dashboard.position3] || null"
              alignment="right"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
        </v-row>
        <v-row
          justify="space-between"
          class="row-section row-even contain-width"
        >
          <v-col cols="4" class="widget widget-middle widget-left inner">
            <component
              :is="dashboard.position4"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position4"
              position="position4"
              :widget-data="dashboard[dashboard.position4] || null"
              alignment="left"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
          <v-col cols="4" class="widget widget-middle widget-center inner">
            <!-- <p>
              {{ $t('loggedIn.welcome') }}
              {{ this.$store.state.authentication.user.displayName }}
            </p> -->
            <component
              :is="dashboard.position5"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position5"
              position="position5"
              :widget-data="dashboard[dashboard.position5] || null"
              alignment="center"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
          <v-col cols="4" class="widget widget-middle widget-right inner">
            <component
              :is="dashboard.position6"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position6"
              position="position6"
              :widget-data="dashboard[dashboard.position6] || null"
              alignment="right"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
        </v-row>
        <v-row
          justify="space-between"
          class="row-section row-odd contain-width"
        >
          <v-col cols="4" class="widget widget-bottom widget-left inner">
            <!-- <component
              :is="dashboard.position7"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position7"
              position="position7"
              :widget-data="dashboard[dashboard.position7] || null"
              alignment="left"
              :language="this.$i18n.locale"
            ></component> -->
          </v-col>
          <v-col cols="4" class="widget widget-bottom widget-center inner">
            <component
              :is="dashboard.position8"
              :paid-plan="user.sub_plan_active"
              :widget-name="dashboard.position8"
              position="position8"
              :widget-data="dashboard[dashboard.position8] || null"
              alignment="center"
              :language="this.$i18n.locale"
            ></component>
          </v-col>
          <v-col cols="4" class="widget widget-bottom widget-right inner">
            <div v-if="!user.sub_plan_active">
              <!-- <component
                :is="subscribe"
                :widget-name="subscribe"
                position="position9"
                :widget-data="null"
                alignment="right"
                :language="this.$i18n.locale"
                class="subscribeBtn"
              ></component> -->
            </div>
            <div v-else>
              <!-- <component
                :is="dashboard.position9"
                :paid-plan="user.sub_plan_active"
                :widget-name="dashboard.position9"
                position="position9"
                :widget-data="dashboard[dashboard.position9] || null"
                alignment="right"
                :language="this.$i18n.locale"
              ></component> -->
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- eslint-disable-next-line -->
    <div id="photo-attrib" v-html="photoSource"></div>
    <user-navigation @log-user-out="logout" />
  </v-container>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/auth'
import { mapActions } from 'vuex'

export default {
  name: 'DashboardView',
  components: {
    // UserNavigation: () =>
    //   import(
    //     /* webpackChunkName: "userNav" */ '@/components/Fabs/UserNavigation'
    //   ),
    UserNavigation: () =>
      import(
        /* webpackChunkName: "userNav" */ '../../components/Fabs/UserNavigation'
      ),
    // Blank: () =>
    //   import(/* webpackChunkName: "blank" */ '@/widgets/Blank/blank'),
    Blank: () =>
      import(/* webpackChunkName: "blank" */ '../../widgets/Blank/blank'),
    Clock: () =>
      import(/* webpackChunkName: "clock" */ '../../widgets/Clock/clock'),
    Wifi: () => import(/* webpackChunkName: "wifi" */ '../../widgets/Wifi/wifi'),
    Weather: () =>
      import(/* webpackChunkName: "weather" */ '../../widgets/Weather/weather'),
    Demo: () => import(/* webpackChunkName: "demo" */ '../../widgets/Demo/demo'),
    Todo: () => import(/* webpackChunkName: "todo" */ '../../widgets/Todo/todo'),
    News: () => import(/* webpackChunkName: "news" */ '../../widgets/News/news'),
    Subscribe: () =>
      import(
        /* webpackChunkName: "subscribe" */ '../../widgets/Subscribe/subscribe'
      ),
    PeopleInSpace: () =>
      import(
        /* webpackChunkName: "peopleinspace" */ '../../widgets/PeopleInSpace/peopleInSpace'
      ),
    Quotes: () =>
      import(/* webpackChunkName: "quotes" */ '../../widgets/Quotes/quotes'),
    Currency: () =>
      import(/* webpackChunkName: "currency" */ '../../widgets/Currency/currency')
    // Crypto: () => import('@/widgets/Crypto/crypto')
  },
  props: {
    dashboard: {
      type: Object,
      default: null
    },
    settings: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      default: null
    },
    photoSource: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLayout: false
    }
  },
  created() {
    if (this.$store.state.app.networkOnLine) {
      this.$i18n.locale = this.settings.userLang
      localStorage.setItem('language', JSON.stringify(this.settings.userLang))
    } else {
      this.$i18n.locale = JSON.parse(localStorage.getItem('language'))
    }
  },
  methods: {
    ...mapActions('app', [
      'closeAddToHomeScreenModalForApple',
      'serviceWorkerSkipWaiting'
    ]),
    async logout() {
      await firebase.auth().signOut()
    }
  }
}
</script>

<style lang="scss" scoped>
.contain-width {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.widget {
  height: 100%;
  &.widget-left {
    text-align: left;
  }
  &.widget-center {
    text-align: center;
  }
  &.widget-right {
    text-align: right;
  }
}
.subscribeBtn {
  align-items: flex-end;
  height: 100%;
}

.fill-container {
  height: 100%;
  .over-padding {
    padding: 0px;
  }
}
.row-height {
  height: 33%;
}
.inner-item {
  border: 1px solid white;
  color: white;
  height: 100%;
}
.top-left {
  text-align: left;
}
.top-center {
  text-align: center;
}
.top-right {
  text-align: right;
}
</style>
<style lang="scss">
#photo-attrib {
  position: absolute;
  bottom: 10px;
  font-size: 10px;
  font-weight: 200;
  color: white;
  z-index: 1000;
  a {
    font-weight: 300;
    color: white;
    &:hover {
      color: white;
    }
  }
}
</style>
